import { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";


const ProtectedRoute=({children}:{children: JSX.Element})=>{
const {token}=useAuth();
return token?children:<Navigate to="/"/>;
};
export default ProtectedRoute;